import api from "@/api";
import store from "@/utils/store.js";

import { from } from "appcx-lib";
import { page } from "vue-analytics";

function convertPageXML(xml) {
  const data = from(xml, {
    what: "regions+lines+attributes",
  });

  for (var temp in data) {
    if(data[temp].type === 'TableRegion'){
      console.log('convertPageXML')
      console.log(data[temp].children)
      for(var cell in data[temp].children){
        var line = data[temp].children[cell]
        line.children = line.children.map((element) => ({
          id: element.id,
          content: element.text.join(" "),
          rect: toRect(element.coords),
          attributes: element.attributes,
          hasTag: hasTag(element.attributes.custom),
          tags: getTags(element.attributes.custom),
          type: element.type
        }));
      }
    }else{
      data[temp].children = data[temp].children.map((element) => ({
        id: element.id,
        content: element.text.join(" "),
        rect: toRect(element.coords),
        attributes: element.attributes,
        hasTag: hasTag(element.attributes.custom),
        tags: getTags(element.attributes.custom),
        type: element.type
      }));
    }
   
  }
  console.log(data)
  return data
}

function getTags(attributes) {
  var tags = [];
  for (var i = 0; i < attributes.length; i++) {
    if (
      "offset" in attributes[i].attributes &&
      "length" in attributes[i].attributes
    ) {
      tags.push(attributes[i]);
    }
  }
  return tags;
}

function hasTag(attributes) {
  for (var i = 0; i < attributes.length; i++) {
    if (
      "offset" in attributes[i].attributes &&
      "length" in attributes[i].attributes
    ) {
      return true;
    }
  }
  return false;
}

function toRect(points) {
  const xMin = Math.min(...points.map((p) => p.x));
  const xMax = Math.max(...points.map((p) => p.x));
  const yMin = Math.min(...points.map((p) => p.y));
  const yMax = Math.max(...points.map((p) => p.y));

  return {
    x: xMin,
    y: yMin,
    width: xMax - xMin,
    height: yMax - yMin,
  };
}

// TODO: move this to BrowserPage component, vuex is not really warranted here

const state = () => {
  return {
    document: null,
    textVisible: null,
    toggledTextVisibility: false,
    pageContent: null,
    pageURL: null,
    searchResults: null,
    selectedElements: [],
    eventSource: null,
    displayMode: "overlay",
    tagMode: "showtags",
    imageUrl: null,
    params: null,
    ready: false,
  };
};

const mutations = {
  SET_EVENT_SOURCE(state, value) {
    state.eventSource = value;
  },
  SET_DISPLAY_MODE(state, value) {
    state.displayMode = value;
  },
  SET_TAG_MODE(state, value) {
    state.tagMode = value;
  },
  CLEAR_SELECTED_ELEMENTS(state) {
    state.selectedElements = [];
  },
  TOGGLE_SELECTED_ELEMENT(state, element) {
    const index = state.selectedElements.indexOf(element);

    if (index === -1) {
      // no mutli select
      state.selectedElements = [element];
    } else {
      state.selectedElements.splice(index, 1);
    }
  },
  ADD_SELECTED_ELEMENT(state, element) {
    if (!state.selectedElements.includes(element)) {
      state.selectedElements.push(element);
    }
  },
  REMOVE_SELECTED_ELEMENT(state, element) {
    const index = state.selectedElements.indexOf(element);
    if (index !== -1) {
      state.selectedElements.splice(index, 1);
    }
  },
  SET_TEXT_VISIBILITY(state, value) {
    state.toggledTextVisibility = true;
    state.textVisible = value;
  },
  SET_PAGE_CONTENT(state, data) {
    state.pageContent = data;
  },
  SET_PAGE_URL(state, data) {
    state.pageURL = data;
  },
  SET_SEARCH_RESULTS(state, data) {
    state.searchResults = data;
  },
  SET_IMAGE_URL(state, url) {
    state.imageUrl = url;
  },
  SET_DOCUMENT(state, value) {
    state.document = value;
  },
  SET_READY(state, value) {
    state.ready = value;
  },
  SET_PARAMS(state, value) {
    state.params = value;
  },
};

const actions = {
  clear({ commit }) {
    commit("CLEAR_SELECTED_ELEMENTS");
    commit("SET_PAGE_CONTENT", null);
    commit("SET_SEARCH_RESULTS", null);
    commit("SET_IMAGE_URL", null);
    commit("SET_PARAMS", null);
    commit("SET_READY", false);
  },
  clearSelectedElements({ commit }) {
    commit("CLEAR_SELECTED_ELEMENTS");
  },
  addSelectedElement({ commit }, element) {
    commit("ADD_SELECTED_ELEMENT", element);
  },
  toggleSelectedElement({ commit }, element) {
    commit("TOGGLE_SELECTED_ELEMENT", element);
  },
  setEventSource({ commit }, value) {
    commit("SET_EVENT_SOURCE", value);
  },
  toggleElementTextVisibility({ dispatch, state }, element) {
    if (!state.selectedElements.includes(element)) {
      dispatch("addSelectedElement", element);
    } else {
      dispatch("removeSelectedElement", element);
    }
  },
  removeSelectedElement({ commit }, element) {
    commit("REMOVE_SELECTED_ELEMENT", element);
  },
  setDisplayMode({ commit }, value) {
    commit("SET_DISPLAY_MODE", value);
  },
  setTagMode({ commit }, value) {
    commit("SET_TAG_MODE", value);
  },
  setReady({ commit }, value) {
    commit("SET_READY", value);
  },
  async toggleTextVisibility({ state, commit }) {
    commit("SET_TEXT_VISIBILITY", !state.textVisible);
  },
  async setTextVisibility({ commit }, value) {
    commit("SET_TEXT_VISIBILITY", value);
  },
  async loadPage({ state, dispatch, commit }) {
    const { document, page } = state.params;

    const { image, content } = await api.fetchPageByNum({
      id: document,
      pageNum: page,
    });

    await dispatch("loadPageContent", content);

    commit("SET_IMAGE_URL", image);
  },
  async loadPageContent({ state, commit }, url) {
    commit("SET_PAGE_URL", url);
    const data = await api.fetchPageContent(url);
    commit("SET_PAGE_CONTENT", convertPageXML(data));
  },
  async loadDocument({ commit, state }) {
    const { document } = state.params;
    const data = await api.fetchDocument(document);

    commit("SET_DOCUMENT", data);
  },
  async loadSearchResults({ commit, dispatch, state }) {
    const { term, titles, document, page, fuzziness } = state.params;

    if (!term) {
      commit("SET_SEARCH_RESULTS", []);
    } else {
      const data = await api.fetchSearchResults(
        {
          term,
          documents: [document],
          titles,
          page,
          fuzziness,
        },
        {
          offset: 0,
          limit: 100,
        }
      );

      const { results } = data;

      commit(
        "SET_SEARCH_RESULTS",
        results.length > 0 ? results[0].snippets : []
      );
    }
  },
  async load({ commit, dispatch }, { term, document, page } = {}) {
    commit("SET_READY", false);

    commit("SET_PARAMS", { term, document, page });

    await Promise.all([
      dispatch("loadDocument"),
      dispatch("loadPage"),
      dispatch("loadSearchResults"),
    ]);

    commit("SET_READY", true);
  },
};

const getters = {
  isReady: (state) => state.ready,
  isLoading: (state) => !state.ready,
  isTextVisible: (state) => state.textVisible,
  pageURL: (state) => state.pageURL,
  image: (state) => state.imageUrl,
  hasToggledTextVisibility: (state) => state.toggledTextVisibility,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
